import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {UmpirePageTemplate} from '@tisa-group/models';

@Injectable({
  providedIn: 'root',
})
export class CurrentPageService implements CrudService {
  constructor(readonly http: TisaUmpireHttpService) {}

  get(
    slug: string,
    include: string,
    season_id?: string,
  ): Observable<JsonApiResponse<UmpirePageTemplate>> {
    const params: {slug: string; include: string; season_id?: string} = {slug, include};

    if (season_id) {
      params.season_id = season_id;
    }

    return this.http
      .get('/current_page', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
